export default function getProductIdsFromCartCookie(): Array<string> {
    const cart_cookie = document.cookie.replace(/(?:(?:^|.*;\s*)cart\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    let product_ids = [];

    if (cart_cookie) {
      const decoded_cookie = decodeURIComponent(cart_cookie);

      if (decoded_cookie.includes(',')) {
        const products = decoded_cookie.split(',');

        products.forEach(product => {
          product_ids.push(product.split('|')[0]);
        });
      } else {
        product_ids.push(decoded_cookie.split('|')[0]);
      }
    }

    return product_ids;
}